import {apiCall} from "../../common/apiActionHandler";
import axios from "axios";

export const loadReport = (filters, callback) => async (dispatch, getState) => {
    const config = {
        url: `/api/sales_cross_view/${filters.person_id}`,
        params: filters
    };

    apiCall("Getting sales report", config, async config => {
        const response = await axios.request(config);
        callback(response.data);
    }, dispatch, getState, false);
};